define([
    'jquery',
    'underscore'
    // "common/lib/date"
], function ($, _) {

    function getDayOfMonthSuffix(day) {
        if (day >= 11 && day <= 13) return "th";

        switch (day % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    }

    /**
     * Can return:
     * July 9th, 2012
     * July 9th | 2012
     * July 9th
     * July 9
     * Jul 9
     *
     * @param {Number|Date|String|Null} rawDate
     * @param {Object} settings can contain boolean properties: shortMonth, noYear, suffix and String property separator
     * @return {String}
     */
    function format(rawDate, settings) {
        if (!rawDate && rawDate !== 0) return ''; // don't return if date is just 0, which !rawDate will catch

        var settings = settings || {},
            separator = settings.separator ? settings.separator : ', ',
            baseDate = _.isDate(rawDate) ?
                rawDate :
                (_.isNumber(rawDate) ? new Date(rawDate) : Date.parse(rawDate)),

            date = settings.local ? (Date.parse(baseDate).addMilliseconds(Date.today().getUTCOffset() * 36000)) : baseDate,

            day = date.getDate(),
            time = (settings.time ? date.toString("h:mm tt") + separator : ""),
            month = settings.shortMonth ? date.toString("MMM") : date.toString("MMMM"),
            year = settings.noYear ? '' : separator + date.getFullYear();

        if (settings.suffix) day += getDayOfMonthSuffix(day);

        return time + month + ' ' + day + year;
    }

    /**
     * @param {Number} timestamp UTC timestamp (in seconds)
     * @param {Object} settings settings can contain boolean properties: shortMonth, noYear, suffix and String property separator
     * @return {String} [amount of time] [unit of time] ago
     */
    function timeAgo(timestamp, settings) {

        settings = settings || {};
        settings.dayThreshold = settings.dayThreshold || 3;

        var timeDiff = Math.round(new Date().getTime() / 1000) - timestamp;

        // older than provided threshold, just return the date string
        if (timeDiff >= settings.dayThreshold * 86400) {
            settings.noYear = timeDiff <= 86400 * 365;
            return format(timestamp * 1000, settings);
        }

        // less than a minute ago
        if (timeDiff < 60){
            return "just now";
        }

        var brackets = [
            {unit: 'minute', maxValue: 3600, divisor: 60},
            {unit: 'hour', maxValue: 86400, divisor: 3600},
            {unit: 'day', maxValue: 86400 * 7, divisor: 86400},
            {unit: 'week', maxValue: 86400 * 30, divisor: 86400 * 7},
            {unit: 'month', maxValue: 86400 * 365, divisor: 86400 * 30}
        ];

        for (var i=0; i < brackets.length; i++) {
            var bracket = brackets[i];
            if (timeDiff < bracket.maxValue) {
                var quantity = Math.round(timeDiff / bracket.divisor);
                var suffix = bracket.unit + (quantity == 1 ? "" : "s") + " ago";
                return quantity + " " + suffix;
            }
        }

        return "Over a year ago";
    }

    return {
        format: format,
        timeAgo: timeAgo
    };
});
